import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-payout_ia_cta-click';
/**
 * Payout option update CTA in instant answer click event
 */
export function trackHelpCenterPayoutIaCtaClick(brandToken, issue_type) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { brandToken, issue_type },
    });
}
